<template>
  <switches
    v-model="inputValue"
    v-bind="$attrs"
    class="app-switch"
    color="primary"
    theme="custom"
    type-bold
  />
</template>

<script>
import Switches from 'vue-switches'

export default {
  name: 'AppSwitch',

  components: {
    Switches,
  },

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    inputValue: {
      get() {
        return this.modelValue
      },

      set(value) {
        this.$emit('update:modelValue', value)
      },
    },
  },
}
</script>

<style lang="scss">
@use 'sass:color';

@use '@/styles/settings.scss' as *;

.vue-switcher {
  div {
    &:after {
      top: -2px;
    }
  }
}

.vue-switcher-theme--custom {
  &.vue-switcher-color--primary {
    div {
      background-color: color.adjust($primaryColor, $lightness: 15%);

      &:after {
        // for the circle on the switch
        background-color: color.adjust($primaryColor, $lightness: -5%);
      }
    }

    &.vue-switcher--unchecked {
      div {
        background-color: color.adjust(#ccc, $lightness: 8%);

        &:after {
          background-color: color.adjust(#ccc, $lightness: 2%);
        }
      }
    }
  }
}
</style>
